import React from "react";
import { customerInModalSelectStyles, modalSelectPortalProps } from "./customerSelectInModal";

export const classSelectStyles = {
  ...customerInModalSelectStyles,
  menuList: (provided) => ({
    ...provided,
    maxHeight: 280,
    paddingTop: 4,
    paddingBottom: 4,
  }),
};

export { modalSelectPortalProps as classSelectPortalProps };

export function formatClassHeadcount(cls) {
  const active = Number(cls?.student_active_count ?? 0);
  const total = Number(cls?.student_total_count ?? active);
  return `${active}/${total}`;
}

export function buildClassLine1(cls) {
  const parts = [
    cls?.name,
    cls?.course_name,
    `Sĩ số ${formatClassHeadcount(cls)}`,
  ].filter(Boolean);
  return parts.join(" - ");
}

export function buildClassLine2(cls) {
  const unit =
    (typeof cls?.school_name === "string" && cls.school_name.trim()) ||
    (cls?.class_type === "center" ? "Trung tâm" : "");
  const ward =
    (typeof cls?.school_ward === "string" && cls.school_ward.trim()) ||
    (typeof cls?.ward === "string" && cls.ward.trim()) ||
    "";
  if (unit && ward) return `${unit} - ${ward}`;
  return unit || ward || "";
}

export function formatClassOptionLabel(opt, meta) {
  const { context, selectProps } = meta || {};
  const line1 = opt.line1 || opt.label || "";
  const line2 = opt.line2 || "";
  const isSelected =
    context === "menu" &&
    selectProps?.value != null &&
    String(selectProps.value?.value) === String(opt.value);

  if (context === "value") {
    return (
      <span className="truncate block max-w-full text-sm font-medium text-gray-800">
        {line1}
      </span>
    );
  }

  return (
    <div className="text-left py-0.5">
      <div
        className={`font-semibold leading-snug ${
          isSelected ? "text-white" : "text-gray-800"
        }`}
      >
        {line1}
      </div>
      {line2 ? (
        <div
          className={`text-[11px] mt-0.5 leading-snug ${
            isSelected ? "text-white/75" : "text-gray-400"
          }`}
        >
          {line2}
        </div>
      ) : null}
    </div>
  );
}

export function filterClassOption(option, inputValue) {
  const opt = option?.data ?? option;
  const q = String(inputValue || "").trim().toLowerCase();
  if (!q) return true;
  return String(opt.searchText || "").toLowerCase().includes(q);
}

export function mapClassesToSelectOptions(classes) {
  return (Array.isArray(classes) ? classes : []).map((c) => {
    const line1 = buildClassLine1(c);
    const line2 = buildClassLine2(c);
    return {
      value: c.id,
      label: line1,
      line1,
      line2,
      searchText: [
        c.name,
        c.code,
        c.course_name,
        c.school_name,
        c.school_ward,
        line1,
        line2,
        formatClassHeadcount(c),
      ]
        .filter(Boolean)
        .join(" "),
    };
  });
}

/** Props chung cho react-select chọn lớp trong modal */
export const classSelectCommonProps = {
  styles: classSelectStyles,
  isSearchable: true,
  filterOption: filterClassOption,
  formatOptionLabel: formatClassOptionLabel,
  maxMenuHeight: 280,
  menuPlacement: "auto",
  ...modalSelectPortalProps,
};
